import { useEffect, useRef, useState } from "react";
import CommonTable from "../../../../components/comman/CommonTable";
import MainHeading from "../../../../components/comman/MainHeading";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../../components/comman/MainFilterHandler";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import FilterComponent from "../../../../components/comman/FilterComponent";
import PlusIcon from "../../../../components/Icons/PlusIcon";
import { RoutesLink } from "../../../../ApiHelper/RoutesLink";
import EditIcon from "../../../../components/Icons/EditIcon";
import ViewIcon from "../../../../components/Icons/ViewIcon";
import { useNavigate } from "react-router-dom";
import ConfirmModal from "../../../../components/comman/ConfirmModal";
import { useDispatch, useSelector } from "react-redux";
import { updateFiltersStates } from "../../../../store/actions/UserActions";

export default function VendorList() {
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const timeoutId = useRef(null);
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [selectedId, setSelectedId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    searchQuery: "",
    vendorList: [],
  });

  useEffect(() => {
    GetVendorList();
  }, [
    pageStates?.currentPage,
    pageStates?.searchQuery,
    pageStates?.pageSize,
    filterDetails?.orderBy,
  ]);
  const formatVendorType = (type) => {
    if (!type) return "";
    if (Array.isArray(type)) return type.join(", ");
    if (typeof type === "string") {
      try {
        const parsed = JSON.parse(type);
        if (Array.isArray(parsed)) return parsed.join(", ");
        return type;
      } catch {
        return type;
      }
    }
    return String(type);
  };

  const GetVendorList = (pageNo) => {
    let options = {
      method: "GET",
    };
    const filterParams = {
      ...pageStates,
      ...(pageNo !== undefined && { currentPage: pageNo }),
      orderBy: filterDetails?.orderBy,
    };
    if (pageStates.searchQuery) {
      delete filterParams.currentPage;
      delete filterParams.pageSize;
    }
    const queryParams = MainFilterHandler(filterParams);
    const Url = apiUrl.get_vendor + (queryParams ? `?${queryParams}` : "");

    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));

    callApi(Url, options)
      .then((res) => {
        if (res?.status === true) {
          const vendorArray = Array.isArray(res?.data)
            ? res.data
            : Array.isArray(res?.data?.vendor)
            ? res.data.vendor
            : Array.isArray(res?.data?.vendors)
            ? res.data.vendors
            : Array.isArray(res?.data?.data)
            ? res.data.data
            : [];

          const newData = vendorArray.map((item) => ({
            ...item,
            typeOfVendor: formatVendorType(item?.type),
            toggleStatus: item?.status,
          }));

          setPageStates((pre) => ({
            ...pre,
            tableLoader: false,
            vendorList: newData,
            count: res?.data?.pageInfo?.total ?? vendorArray.length,
            totalPages: res?.data?.pageInfo?.totalPages ?? 1,
          }));
        } else {
          setPageStates((pre) => ({
            ...pre,
            tableLoader: false,
            vendorList: [],
          }));
          if (res?.message) {
            toast.error(res?.message);
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching vendor list:", err);
        setPageStates((pre) => ({
          ...pre,
          tableLoader: false,
        }));
      });
  };

  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
        ...(value === "" && { currentPage: 1, pageSize: 10 }),
      }));
    }, 500);
  };

  const HandleView = (data) => {
    navigate(`${RoutesLink?.vendor_detail}/${data?.id}`);
  };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.add_vendor, { state: { data: data } });
  };

  const ActionHandler = (data) => {
    setSelectedId(data?.id);
    toggle();
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.delete_vendor + `?vendorId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggle();
        GetVendorList(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
        toggle();
      }
    });
  };

  const handleStatusToggle = (data, status) => {
    let submitData = {};
    submitData = {
      status: status ? 0 : 1,
    };
    const options = {
      method: "POST",
      data: submitData,
    };
    let API = apiUrl?.update_vendor_status + `?vendorId=${data?.id}`;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        toast.success(response?.message);
        GetVendorList(pageStates?.currentPage);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const TableHeading = [
    { value: "vendorNumber", label: "Vender Code" },
    { value: "firmName", label: "Firm" },
    { value: "typeOfVendor", label: "Vendor Type" },
    { value: "email", label: "email" },
    { value: "name", label: "Contact Person" },
    { value: "phone", label: "Contact No." },
    { value: "toggleStatus", label: "Status" },
  ];

  const ActionData = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      clickHandler: HandleUpdate,
    },
    // {
    //     label: "Delete",
    //     className: "btn btn-link",
    //     icon: <DeleteIcon />,
    //     title: "delete",
    //     // isShow: 0,
    //     clickHandler: ActionHandler,
    // },
  ];

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <>
        <div className="content">
          <MainHeading
            title={"Vendor"}
            buttonText={"Add Vendor"}
            buttonIcon={<PlusIcon />}
            buttonLink={RoutesLink?.add_vendor}
          />
          <div className="card mb-4">
            <div className="card-body">
              <FilterComponent
                handleSearch={handleSearchChange}
                orderByHandler={orderByHandler}
                orderByList={orderByList}
              />
              <CommonTable
                TableHeading={TableHeading}
                TableData={pageStates?.vendorList}
                ActionData={ActionData}
                currentPage={pageStates?.currentPage}
                PageChangeHandler={PageChangeHandler}
                isLoading={pageStates?.tableLoader}
                totalPages={pageStates?.totalPages}
                count={pageStates?.count}
                handleStatusToggle={handleStatusToggle}
                handleChangePageSize={handleChangePageSize}
                pageSize={pageStates.pageSize}
              />
            </div>
          </div>
        </div>
      </>
      <ConfirmModal
        modal={modal}
        toggle={toggle}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
    </>
  );
}
